import React, { useContext } from 'react';
import Box from 'js/components/box/box';
import { MATCHED_APPS_REGION } from '../../../constants';
import ContextDetailContext from '../../../contexts/context-detail.context';
import PageSection from '../../page-section/page-section';
import styles from '../matched-items-section.module.scss';
import MatchedApps from './matched-apps';
import ReloadNotice from '../reload-notice';
import RegionFilter from '../region-filter';

export default function MatchedAppsSection() {
    const {
        matchedApps: {
            load: getMatchedApps,
            needsReload: needsMatchedAppsReload,
            region,
            setRegion,
        },
    } = useContext(ContextDetailContext);

    const updateRegion = (r) => {
        setRegion(r);
        localStorage.setItem(MATCHED_APPS_REGION, r);
    };

    return (
        <div className={styles['matched-items-section']}>
            <PageSection
                title="Matched Apps"
                description="These are the apps that have the strongest
                match to this context. You can use them to verify
                or improve the accuracy of this context."
                extension={[
                    <RegionFilter value={region} onChange={updateRegion} />,
                ]}
            >
                <Box padding={['base', 0, 0, 0]}>
                    {needsMatchedAppsReload && (
                        <div className={styles.notices}>
                            <ReloadNotice
                                onReload={() => {
                                    getMatchedApps();
                                }}
                            />
                        </div>
                    )}

                    <MatchedApps />
                </Box>
            </PageSection>
        </div>
    );
}
